import { combineActions, handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as actionTypes from './constants';

export const kpisLandingZone = handleActions({
  [combineActions(
    actionTypes.KPI_LANDING_ZONE_REQUEST,
    actionTypes.KPI_LANDING_ZONE_FAILURE,
  )]: () => [],
  [actionTypes.KPI_LANDING_ZONE_SUCCESS]: (action, { payload }) => payload.kpis,
}, []);

export const campaignsLandingZone = handleActions({
  [combineActions(
    actionTypes.CAMPAIGNS_LANDING_ZONE_REQUEST,
    actionTypes.CAMPAIGNS_LANDING_ZONE_FAILURE,
  )]: () => [],
  [actionTypes.CAMPAIGNS_LANDING_ZONE_SUCCESS]: (action, { payload }) => payload,
  [actionTypes.CAMPAIGN_LANDING_ZONE_SUCCESS]: (action, { payload }) => action?.map((a) => {
    if (a.runningCampaign.id === payload[0].runningCampaign.id) {
      return payload[0];
    }
    return a;
  }),
}, []);

export const isLoadingKpisLandingZone = handleActions({
  [combineActions(
    actionTypes.KPI_LANDING_ZONE_SUCCESS,
    actionTypes.KPI_LANDING_ZONE_FAILURE,
  )]: () => false,
  [actionTypes.KPI_LANDING_ZONE_REQUEST]: () => true,
}, false);

export const isLoadingCampaignsLandingZone = handleActions({
  [combineActions(
    actionTypes.CAMPAIGNS_LANDING_ZONE_SUCCESS,
    actionTypes.CAMPAIGNS_LANDING_ZONE_FAILURE,
  )]: () => false,
  [actionTypes.CAMPAIGNS_LANDING_ZONE_REQUEST]: (action, { payload }) => !payload?.keepGrid,
}, false);

export const isLoadingCampaignLandingZone = handleActions({
  [combineActions(
    actionTypes.CAMPAIGN_LANDING_ZONE_SUCCESS,
    actionTypes.CAMPAIGN_LANDING_ZONE_FAILURE,
  )]: () => false,
  [actionTypes.CAMPAIGN_LANDING_ZONE_REQUEST]: () => true,
}, false);

export const fetchCampaignsLandingZoneSuccess = handleActions({
  [combineActions(
    actionTypes.RESET_CAMPAIGN_SUCCESS,
    actionTypes.CAMPAIGNS_LANDING_ZONE_REQUEST,
    actionTypes.CAMPAIGNS_LANDING_ZONE_FAILURE,
  )]: () => false,
  [actionTypes.CAMPAIGNS_LANDING_ZONE_SUCCESS]: () => true,
}, false);

export const error = handleActions({
  [combineActions(
    actionTypes.CAMPAIGNS_LANDING_ZONE_REQUEST,
    actionTypes.CAMPAIGNS_LANDING_ZONE_SUCCESS,
    actionTypes.CAMPAIGN_LANDING_ZONE_REQUEST,
    actionTypes.CAMPAIGN_LANDING_ZONE_SUCCESS,
    actionTypes.KPI_LANDING_ZONE_REQUEST,
    actionTypes.KPI_LANDING_ZONE_SUCCESS,
  )]: () => false,
  [combineActions(
    actionTypes.CAMPAIGNS_LANDING_ZONE_FAILURE,
    actionTypes.CAMPAIGN_LANDING_ZONE_FAILURE,
    actionTypes.KPI_LANDING_ZONE_FAILURE,
  )]: (action, { payload }) => payload?.error,
}, false);

export default combineReducers({
  kpisLandingZone,
  campaignsLandingZone,
  isLoadingKpisLandingZone,
  isLoadingCampaignsLandingZone,
  isLoadingCampaignLandingZone,
  fetchCampaignsLandingZoneSuccess,
  error,
});
